import { useMemo } from 'react';
import type { DealEventTct } from '@dealstack/shared/lib/backendClient';
import { BasicMantineTable } from '@dealstack/frontend/shared/components/BasicMantineTable/BasicMantineTable.tsx';
import { getAuditListColumns } from '@dealstack/frontend/shared/components/Audit/AuditLayout/auditTableColumns.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TransformedAuditData } from '@dealstack/frontend/shared/components/Audit/types.ts';
import { getDealEventChangeAction } from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogChanges.utils.ts';

interface Props {
	event: DealEventTct;
	changes: TransformedAuditData[];
}

export const DealEventChangesTable = ({ event, changes }: Props) => {
	const tCapManage = useTranslationCapManage();

	const columns = useMemo(
		() => getAuditListColumns({ tCapManage, auditAction: getDealEventChangeAction(event) }),
		[event, tCapManage]
	);

	return (
		<BasicMantineTable
			columns={columns}
			data={changes}
			hideTopToolbar
			enableVerticalCellBorders
			dataTestId="deal-event-changes-table"
		/>
	);
};
